import React, { Component } from 'react';
import { Input, Button, Select } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import $ from 'jquery';
import './style.css';


import { save_user } from './actions/register.action';

const Option = Select.Option;
class Register extends Component {

    constructor( props ) {
        super( props );
        this.state = {
            company: '',
            full_name: 'none',
            username: 'none',
            email: 'none',
            password: 'none',
            rpassword: 'none',
        }
        this.onSubmitEvent = this.onSubmitEvent.bind( this );
        this.handleUsername = this.handleUsername.bind( this );
        this.handleEmail = this.handleEmail.bind( this );
        this.handlePassword = this.handlePassword.bind( this );
        this.handleRPassword = this.handleRPassword.bind( this );
        this.handleType = this.handleType.bind( this );
    }
    handleUsername( e ){
      const value = e.target.value;
      this.setState({
          username: value
      })
    }
    handleEmail( e ){
      const value = e.target.value;
      this.setState({
          email: value
      })
    }
    handlePassword( e ){
      const value = e.target.value;
      this.setState({
          password: value
      })
    }
    handleRPassword( e ){
      const value = e.target.value;
      this.setState({
          rpassword: value
      })
    }
    handleType( value ){
      this.setState({
          type: value
      })
    }
    onSubmitEvent( e ){
        e.preventDefault();

        let user_pattern = new RegExp('^([a-zA-Z0-9_-]+)$');
        let username = user_pattern.test( this.state.username );

        let email_pattern = /(\w(=?@)\w+\.{1}[a-zA-Z]{2,})/i;
        let email = email_pattern.test( this.state.email );

        if( this.state.full_name === '' || this.state.full_name === 'none' ){
            this.setState({ full_name: '' });
            return false;
        }
        if( this.state.username === '' || this.state.username === 'none' || username === false ){
            this.setState({ username: '' });
            return false;
        }
        if( this.state.email === '' || this.state.email === 'none' || email === false ){
            this.setState({ email: '' });
            return false;
        }
        if( this.state.password === '' || this.state.password === 'none' || this.state.password !== this.state.rpassword ){
            this.setState({ password: '', rpassword: '' });
            $('input[type="password"]').val('');
            return false;
        }

        this.props.save_user( this.state );

    }

    componentWillMount(){

        this.setState({
            company: this.props.match.params.company
        })

    }

    componentWillReceiveProps( nextProps ){
        
        if( nextProps.register.STATUS.CODE === "200" ) {
            this.props.history.push( '/login' );
        }
        if( nextProps.register.STATUS.CODE === "400" ) {
            alert( nextProps.register.STATUS.MESSAGE )
        }

    }

    render() {
        return (
            <div className="register-wrapper animated fadeIn">
                
                <div className="register-header"></div>

                <div className="register-forms">
                    <form method="post" autoComplete="off" onSubmit={ this.onSubmitEvent }>
                        <Input placeholder="Full Name" size="large" onChange={ (e) => this.setState({ full_name: e.target.value }) }
                            className={ ( this.state.full_name === '') ? 'br_error input': 'input'} />
                        <Input placeholder="User Name ( only letters and numbers )" size="large" onChange={ this.handleUsername }
                            className={ ( this.state.username === '') ? 'br_error input': 'input'} />
                        <Input placeholder="User's Email" size="large" onChange={ this.handleEmail }
                            className={ ( this.state.email === '') ? 'br_error input': 'input'} />
                        <Input placeholder="Password" size="large" onChange={ this.handlePassword } type="password"
                            className={ ( this.state.password === '') ? 'br_error input': 'input'} />
                        <Input placeholder="Repeat Password" size="large" onChange={ this.handleRPassword } type="password"
                            className={ ( this.state.rpassword === '') ? 'br_error input': 'input'} />
                        <Button htmlType="submit" type="primary" size="large" className="button">Register</Button>
                        <Button size="large" className="mrg_l_10"><Link to="/login">Back</Link></Button>
                    </form>
                </div>

            </div>
        );
    }

}

function mapStateToProps( state ) {
    return {
        register: state.register
    }
}
export default connect( mapStateToProps, { save_user } )( Register );



// WEBPACK FOOTER //
// ./src/pages/register/index.js